import React, { useState } from 'react';
import Seo from '../../components/Seo';
import { companyProfile, contactServices, faqs } from '../../content/siteContent';

function AdmissionContact() {
  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: '',
  });
  const [sent, setSent] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((current) => ({ ...current, [name]: value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setSent(true);
  };

  return (
    <main>
      <Seo
        title="Contact College Admission Team | Vedanskrix"
        description="Contact Vedanskrix College Admission for counselling, shortlisting, application support, visa guidance, and student admission planning."
        keywords={['contact admission consultant', 'college admission contact Ahmedabad', 'student counselling contact']}
      />

      <section className="ca-page-hero ca-page-hero--contact">
        <div className="ca-container">
          <span className="ca-eyebrow">Contact Us</span>
          <h1>Talk to our college admission team.</h1>
          <p>
            Share your preferred destination, intake, and current stage. We will guide you on the
            right next step for your admission plan.
          </p>
        </div>
      </section>

      <section className="ca-section">
        <div className="ca-container ca-contact">
          <div className="ca-contact__info">
            <h2>Get In Touch</h2>
            <p>
              We support students with counselling, shortlisting, application planning, visa
              preparation, and pre-departure guidance.
            </p>

            <div className="ca-contact__cards">
              <article className="ca-contact-card">
                <strong>Office</strong>
                <p>{companyProfile.registeredAddress}</p>
              </article>
              <article className="ca-contact-card">
                <strong>Email</strong>
                <p>
                  <a href={`mailto:${companyProfile.primaryEmail}`}>{companyProfile.primaryEmail}</a>
                </p>
              </article>
              <article className="ca-contact-card">
                <strong>Call / WhatsApp</strong>
                <p>
                  <a href={`tel:${companyProfile.phone.replace(/\s+/g, '')}`}>{companyProfile.phone}</a>
                </p>
              </article>
              <article className="ca-contact-card">
                <strong>Working Hours</strong>
                <p>Mon - Sat: 9:00 AM - 7:00 PM</p>
              </article>
            </div>

            <div className="ca-map">
              <iframe
                title="Vedanskrix office map"
                src="https://www.google.com/maps?q=Akshardham%20Heights%20Vastral%20Ahmedabad&z=15&output=embed"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>

          <div className="ca-contact__form-wrap">
            {sent ? (
              <div className="ca-form-success">
                <h3>Message Sent</h3>
                <p>Thank you. Our admission team will get back to you soon.</p>
              </div>
            ) : (
              <form className="ca-form" onSubmit={handleSubmit}>
                <h3>Send Us Your Query</h3>

                <div className="ca-form__row">
                  <div className="ca-form__group">
                    <label htmlFor="ca-name">Full Name</label>
                    <input
                      id="ca-name"
                      name="name"
                      type="text"
                      required
                      placeholder="Your full name"
                      value={form.name}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="ca-form__group">
                    <label htmlFor="ca-email">Email Address</label>
                    <input
                      id="ca-email"
                      name="email"
                      type="email"
                      required
                      placeholder="your@email.com"
                      value={form.email}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="ca-form__row">
                  <div className="ca-form__group">
                    <label htmlFor="ca-phone">Phone Number</label>
                    <input
                      id="ca-phone"
                      name="phone"
                      type="tel"
                      placeholder="+91 XXXXX XXXXX"
                      value={form.phone}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="ca-form__group">
                    <label htmlFor="ca-service">Support Needed</label>
                    <select id="ca-service" name="service" value={form.service} onChange={handleChange}>
                      <option value="">Select a service</option>
                      {contactServices.map((service) => (
                        <option key={service} value={service}>
                          {service}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="ca-form__group">
                  <label htmlFor="ca-message">Message</label>
                  <textarea
                    id="ca-message"
                    name="message"
                    rows={5}
                    required
                    placeholder="Tell us about your target country, course, or timeline."
                    value={form.message}
                    onChange={handleChange}
                  />
                </div>

                <button type="submit" className="ca-button ca-button--full">
                  Send Message
                </button>
              </form>
            )}

            <div className="ca-faq-mini">
              <h3>Quick Answers</h3>
              {faqs.map((item) => (
                <article key={item.question} className="ca-faq-mini__item">
                  <strong>{item.question}</strong>
                  <p>{item.answer}</p>
                </article>
              ))}
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default AdmissionContact;
